import * as yup from "yup"

export const validationSchema = yup.object({
    username: yup.string().email().required(),
    password: yup.string().min(6).required(),
})

